exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fullscreen-button{position:relative;padding:0;margin:0;cursor:pointer;height:0;width:0;top:70px;left:11px;z-index:9999}.fullscreen-button .svgBg{background-color:#fff;width:24px;height:24px;border-radius:4px;box-shadow:0 0 5px 0 rgba(0,0,0,.75)}.fullscreen-button svg{fill:#000;cursor:pointer}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader?includePaths[]=/app/~/compass-mixins/lib!./src/landing/directives/fullscreen/style.scss
 ** module id = 944
 ** module chunks = 0
 **/